// extracted by mini-css-extract-plugin
export default {"eventInformationWrapper":"XupyNHxLnPlo_P_yiHbQ","description":"GCizNQ4As3YwSShIXUxg","content":"Gm1WWallaNnq0hrHmNCF","rightSide":"qF6BleQiNhGSeCKA5Ioh"};